import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ClientServiceCreateResponseJson,
  ClientType,
  ClientTypeSchema,
  enumNumber,
} from '@vmspdb/definitions';
import { SelectOption } from '@vmspdb/ui/domain';
import * as fromClients from './clients.reducer';

export const selectClientState = createFeatureSelector<fromClients.ClientState>(
  fromClients.clientsFeatureKey,
);

export const selectAllClients = createSelector(
  selectClientState,
  fromClients.selectAll,
);

export const selectSingleClient = (uuid: string) =>
  createSelector(selectAllClientsMapped, (state) => state.get(uuid));

export const selectAllClientsProto = selectAllClients;

export const selectAllClientsMapped = createSelector(
  selectAllClientsProto,
  (clients) => {
    const map = new Map<string, ClientServiceCreateResponseJson>();
    clients.forEach((client) => {
      if (client.uuid) {
        map.set(client.uuid, client);
      }
    });
    return map;
  },
);

export const selectAllClientsContractorMapped = createSelector(
  selectAllClientsProto,
  (clients) => {
    const map = new Map<string, ClientServiceCreateResponseJson>();
    clients.forEach((client) => {
      if (client.uuid) {
        map.set(client.uuid, client);
      }
    });
    return map;
  },
);

export const selectAllClientOptions = createSelector(
  selectAllClientsProto,
  transformOptions,
);

export const selectAllClientOptionsWithNA = createSelector(
  selectAllClientOptions,
  (options) => [
    {
      value: '',
      label: 'N/A',
    },
    ...options,
  ],
);

export const selectAllClientOnlyOptions = createSelector(
  selectAllClientsProto,
  (clients): SelectOption[] =>
    transformOptions(
      clients.filter(
        (client) =>
          enumNumber(ClientTypeSchema, client.type) === ClientType.END_CLIENT,
      ),
    ),
);

export const selectAllClientContractorOptions = createSelector(
  selectAllClientsProto,
  (clients): SelectOption[] =>
    transformOptions(
      // TODO: Reinstate if job contractors are required again
      clients /*.filter(
        (client) =>
          enumNumber(ClientTypeSchema, client.type) === ClientType.CONTRACTOR,
      )*/,
    ),
);

export const selectAllClientSubcontractorOptions = createSelector(
  selectAllClientsProto,
  (clients): SelectOption[] =>
    transformOptions(
      clients.filter(
        (client) =>
          enumNumber(ClientTypeSchema, client.type) ===
          ClientType.SUBCONTRACTOR,
      ),
    ),
);

function transformOptions(
  clients: ClientServiceCreateResponseJson[],
): SelectOption[] {
  const values = clients.sort((a, b) =>
    (a.name || '') < (b.name || '') ? -1 : 1,
  );
  return values
    .filter((item) => item.uuid)
    .map((item) => ({
      value: item.uuid || '',
      label: item.businessName
        ? `${item.name} (${item.businessName})`
        : item.name || '',
    }));
}
